import { render, staticRenderFns } from "./pbrCenterForm.vue?vue&type=template&id=b9b2d196&scoped=true&"
import script from "./pbrCenterForm.vue?vue&type=script&lang=js&"
export * from "./pbrCenterForm.vue?vue&type=script&lang=js&"
import style0 from "./pbrCenterForm.vue?vue&type=style&index=0&id=b9b2d196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b2d196",
  null
  
)

export default component.exports